const { includes, lowerCase } = require('lodash');

class ShelfProductListOfferController {
    constructor($sce) {
        this.$sce = $sce;
    }

    $onInit() {
        this.getHeaderTagStyles();

        // This is a hack for showing centre tags if the special is a multibuy (multibuys don't have tag content containing the word 'was')
        this.centreTagContainsWas = includes(lowerCase(this.product.CentreTag.TagContent), 'was');

        this.shouldShowCentreTag = this.product.IsCentreTag && !this.product.IsDeliveryPass && (!this.product.IsOnSpecial || !this.centreTagContainsWas);
    }

    getHeaderTagStyles() {
        if (this.product.HasHeaderTag) {
            this.headerTagStyle = {
                background: this.product.HeaderTag.BackgroundColor,
                borderColor: this.product.HeaderTag.BorderColor,
                color: this.product.HeaderTag.TextColor,
            };
        }
    }

    getTagContent(tag = this.product.CentreTag) {
        return tag.TagType === 'Html'
            ? this.$sce.trustAsHtml(tag.TagContent)
            : tag.TagContent;
    }

    tagClick(event) {
        // addToTrolley or addMultipleToTrolley are not links anymore
        // they prevent the link to follow href
        if (this.shelfProductService.processTrolleyProductTagLink(this.tag.TagLink)) {
            event.preventDefault();
        }
        this.analytics.push({ data: this.product, type: this.analytics.mapperTypes.customEvent.productClick });
    }

    htmlTagClick(event) {
        // Same as above, however we need to extract the tag link before processing the link
        const regex = /href="(.*?)"|href='(.*?)'/gm;
        const tagLink = this.tag.TagContent.match(regex);
        if (tagLink && this.shelfProductService.processTrolleyProductTagLink(tagLink[0])) {
            event.preventDefault();
        }
    }

    staticTextOnProductPush() {
        this.analytics.pushEvent('staticTextOnProductFooterClick');
    }

    staticTextClick(event) {
        return this.product.CentreTag.TagType === 'Html'
            ? this.htmlTagClick(event)
            : this.staticTextOnProductPush();
    }
}

const shelfProductListOfferComponentDefinition = {
    bindings: {
        product: '<',
    },
    controller: ['$sce', ShelfProductListOfferController],
    template: require('./shelf-product-list-offer.component.html').trim(),
};

module.exports = {
    ShelfProductListOfferController,
    shelfProductListOfferComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/shelfproduct/shelf-product-list-offer.component.js